export const fetchPredictions = async (
  autocompleteService: google.maps.places.AutocompleteService,
  searchValue: string
): Promise<google.maps.places.AutocompletePrediction[]> =>
  new Promise((resolve) => {
    autocompleteService.getPlacePredictions(
      {
        input: searchValue,
        componentRestrictions: { country: "uk" },
        types: ["(regions)"],
      },
      (predictions, placesStatus) => {
        if (
          placesStatus !== google.maps.places.PlacesServiceStatus.OK ||
          !predictions
        ) {
          resolve([]);
          return;
        }

        resolve(predictions);
      }
    );
  });
